import { useNavigate } from 'react-router-dom';
import { PERKS } from '../data/site';
import { useSite } from '../data/SiteContext';

export default function Partners() {
  const navigate = useNavigate();
  const { contact } = useSite();
  return (
    <div style={{ maxWidth:1100, margin:'0 auto', padding:'40px 24px 72px' }}>
      <div className="kicker">For Travel Professionals</div>
      <h1 className="page-h1">Sell more. Handle less.</h1>
      <p className="page-sub">Agents, corporates and content creators — use our contracts, rates and 24/7 ground support as your own.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))', gap:22, marginBottom:30 }}>
        <div className="card-cool" style={{ padding:30, borderRadius:24, boxShadow:'0 12px 30px rgba(16,90,90,0.1)' }}>
          <div className="serif" style={{ fontSize:26, marginBottom:10 }}>Become a Partner</div>
          <p style={{ fontSize:15, lineHeight:1.6, color:'#5a726f', margin:'0 0 18px' }}>Commission from day one, net rates on 40+ destinations, and a dedicated account manager.</p>
          <a href={contact.waLink} target="_blank" rel="noreferrer" className="btn btn-teal" style={{ padding:'14px 26px' }}>Become a Partner</a>
        </div>
        <div style={{ padding:30, borderRadius:24, background:'#0c2b2f', color:'#fff', boxShadow:'0 12px 30px rgba(16,90,90,0.18)' }}>
          <div className="serif" style={{ fontSize:26, marginBottom:10 }}>Partner Login</div>
          <p style={{ fontSize:15, lineHeight:1.6, opacity:.82, margin:'0 0 18px' }}>Access live availability, your bookings, commission statements and marketing assets.</p>
          <span className="btn btn-yellow" onClick={() => navigate('/admin')}>Partner Login</span>
        </div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:18 }}>
        {PERKS.map(p => (
          <div key={p.n} className="card-cool" style={{ padding:24, borderRadius:20 }}>
            <div style={{ fontWeight:800, fontSize:16, marginBottom:6 }}>{p.title}</div>
            <div style={{ fontSize:14, lineHeight:1.55, color:'#5a726f' }}>{p.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
